import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { rem } from '../../../utils/utils';

const wrapperStyles = ({
  theme: {
    work,
    grid: { breakpoint },
  },
}) => css`
  background: ${work.sesameSecondary};
  padding: 0 15px 40px;
  margin: 0 -15px;
  ${breakpoint.min730} {
    padding: 0;
    margin: auto;
    display: grid;
    min-height: 100vh;
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    padding: 0;
  }
`;

const sectionStyles = ({
  theme: {
    grid: { breakpoint },
  },
}) => css`
  display: grid;
  grid-template-areas:
    'continuous-experimentation'
    'ui-development'
    'cost-savings';
  ${breakpoint.fromPhoneMedium} {
    column-gap: 30px;
  }
  ${breakpoint.min730} {
    margin: 0 150px;
    grid-template-columns: repeat(2, 600px);
    grid-template-areas:
      'continuous-experimentation ui-development'
      'cost-savings               cost-savings';
    column-gap: 40px;
    align-self: center;
  }
`;

const blockStyles = ({
  theme: {
    color,
    grid: { breakpoint },
  },
  gridArea,
}) => css`
  grid-area: ${gridArea};
  border-top: 1px solid ${color.grey900Transparent15};
  padding-top: 30px;
  padding-bottom: 30px;
  ${breakpoint.min730} {
    padding-top: 40px;
    padding-bottom: 40px;
  }
`;

const blockWithCostSavingStyles = ({
  gridArea,
  theme: {
    grid: { breakpoint },
  },
}) =>
  gridArea === 'cost-savings' &&
  css`
    display: grid;

    div:first-child {
      order: 2;
    }

    div:last-child {
      margin-bottom: 30px;
    }
    ${breakpoint.min730} {
      grid-template-columns: 1fr 1fr;
      grid-gap: 40px;

      div:first-child {
        order: 1;
      }

      div:last-child {
        order: 2;
      }

      div:last-child {
        margin-bottom: 0;
      }
    }
  `;

const imageWrapperStyles = ({
  theme: {
    grid: { breakpoint },
  },
}) => `
  position: relative;
  ${breakpoint.min730} {
    align-self: flex-end;
  }
`;

const figcaptionStyles = ({
  theme: {
    color,
    font,
    grid: { breakpoint },
  },
}) => css`
  display: none;
  ${breakpoint.fromPhoneMedium} {
    display: block;
    font-size: ${rem(12)};
    font-family: monospace, ${font.inter};
    padding: 0 5px;
    position: absolute;
    bottom: 0;
    right: 0;
    padding-right: 5px;
    background: ${color.black};
    color: ${color.white};
  }
`;

/**
 * Component style declarations
 */
export const Wrapper = styled('div')(wrapperStyles);
export const Section = styled('div')(sectionStyles);
export const ImageWrapper = styled('div')(imageWrapperStyles);
export const Block = styled('div')(blockStyles, blockWithCostSavingStyles);
export const Figcaption = styled('figcaption')(figcaptionStyles);
